import { useEffect, useState } from 'react'
import { api, type BrowserFeatures, type BrowserSettings as Settings } from '../../api/client'
import { useSession } from '../../api/session'

const features: {key: keyof BrowserFeatures; label: string}[] = [
  {key: 'solve_captchas', label: 'Solve CAPTCHAs'},
  {key: 'advanced_stealth', label: 'Use advanced browser stealth'},
  {key: 'proxies', label: 'Use browser proxies'},
]

export default function BrowserSettings() {
  const { user } = useSession()
  const [saved, setSaved] = useState<Settings | null>(null)
  const [draft, setDraft] = useState<BrowserFeatures | null>(null)
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')
  const [status, setStatus] = useState('')
  const [busy, setBusy] = useState(false)
  useEffect(() => {
    let live = true
    api.browserSettings().then(value => { if (live) { setSaved(value); setDraft(value.features) } }).catch(e => { if (live) setError(e.message) })
    return () => { live = false }
  }, [])
  async function reload() {
    setBusy(true)
    try { const value = await api.browserSettings(); setSaved(value); setDraft(value.features); setReason(''); setError(''); setStatus('Settings reloaded') }
    catch (e) { setError(e instanceof Error ? e.message : 'Could not load browser settings') }
    finally { setBusy(false) }
  }
  const admin = user?.role === 'admin'
  const changed = saved && draft && features.some(feature => saved.features[feature.key] !== draft[feature.key])
  return <section className="panel" style={{marginTop: '2rem', maxWidth: '44rem'}}>
    <h2>Website form browser</h2>
    <p className="muted">These settings apply to new form sessions. Each session retains the settings it started with.</p>
    {error && <p className="notice crit" role="alert">{error}</p>}
    {status && <p role="status">{status}</p>}
    {!saved || !draft ? <p className="muted">Loading browser settings…</p> : <form className="reply" onSubmit={async event => {
      event.preventDefault(); setBusy(true); setStatus('')
      try {
        const value = await api.saveBrowserSettings(draft, saved.revision, reason.trim())
        setSaved(value); setDraft(value.features); setReason(''); setError(''); setStatus('Browser settings saved')
      } catch (e) { setError(e instanceof Error ? e.message : 'Could not save browser settings') }
      finally { setBusy(false) }
    }}>
      {features.map(feature => <label className="row" key={feature.key}><input type="checkbox" checked={draft[feature.key]} disabled={!admin || busy} onChange={event => { setDraft({...draft, [feature.key]: event.target.checked}); setStatus('') }} />{feature.label}</label>)}
      <p className="muted">Last changed by {saved.actor} · {new Date(saved.updated_at).toLocaleString()} · {saved.reason}</p>
      {admin && <>
        <label className="field">Reason for change<input className="input" value={reason} maxLength={2000} required onChange={event => setReason(event.target.value)} /></label>
        <div className="action-group"><button className="btn small" disabled={busy || !changed || !reason.trim()}>{busy ? 'Saving…' : 'Save browser settings'}</button><button type="button" className="btn secondary small" disabled={busy} onClick={reload}>Reload saved settings</button></div>
      </>}
    </form>}
  </section>
}
